import { css } from '@emotion/css';
import { Colors } from '../../shared/styles/colors';
import {
  Button,
  ButtonSizeEnum,
  ButtonVariantEnum,
} from '../../shared/components/Button';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { CheckIfPedestalExistsParams } from '../../shared/types/input-param-types';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { EnterCodeInput } from './EnterCodeInput';
import { useEffect } from 'react';
import { h3Style, p2Style } from '../../shared/styles/text';
import { Radius, Shadow } from '../../shared/styles/tokens';
interface EnterCodeModalProps {
  visible: boolean;
  setVisible(value: boolean): void;
  onSubmit(value: string | number): void;
}

const validationSchema = yup.object().shape({
  id: yup.string().required(),
});

export const EnterCodeModal = (props: EnterCodeModalProps): JSX.Element => {
  const { visible, setVisible, onSubmit } = props;
  const methods = useForm({
    defaultValues: { id: '' } as unknown as CheckIfPedestalExistsParams,
    resolver: yupResolver(validationSchema) as any,
  });

  const handler: SubmitHandler<CheckIfPedestalExistsParams> = async (
    data: CheckIfPedestalExistsParams,
  ): Promise<void> => {
    onSubmit(data.id);
  };

  useEffect(() => {
    visible && methods.setFocus('id');
  }, [visible]);

  return (
    <FormProvider {...methods}>
      <form
        className={visible ? modalContainerStyle : notVisibleStyle}
        onSubmit={methods.handleSubmit(handler)}
        role="dialog"
        aria-modal="true"
        aria-labelledby="enter-code-title"
      >
        <div className={headerStyle}>
          <h3 id="enter-code-title" className={h3Style}>
            Enter pedestal ID
          </h3>
          <p className={p2Style}>
            You can find it printed next to the QR code.
          </p>
        </div>
        <EnterCodeInput name="id" />
        <div className={buttonContainerStyle}>
          <Button
            variant={ButtonVariantEnum.TEXT}
            size={ButtonSizeEnum.MEDIUM}
            text="cancel"
            onClick={() => setVisible(false)}
            className={buttonStyle}
            color={Colors.TEXT_SECONDARY}
          />
          <Button
            variant={ButtonVariantEnum.FILLED}
            size={ButtonSizeEnum.MEDIUM}
            text="confirm"
            type={'submit'}
            className={buttonStyle}
          />
        </div>
      </form>
    </FormProvider>
  );
};

const notVisibleStyle = css`
  display: none;
`;

const modalContainerStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(90%, 24rem);
  background-color: ${Colors.WHITE};
  border-radius: ${Radius.xl};
  box-shadow: ${Shadow.raised};
  padding: 1.5rem;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const headerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  p {
    color: ${Colors.TEXT_SECONDARY};
  }
`;

const buttonContainerStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 0.5rem;
`;

const buttonStyle = css`
  padding-left: 1rem;
  padding-right: 1rem;
`;
